import { render, staticRenderFns } from "./operationHistory.vue?vue&type=template&id=2034d5a8&"
import script from "./operationHistory.vue?vue&type=script&lang=js&"
export * from "./operationHistory.vue?vue&type=script&lang=js&"
import style0 from "./operationHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports